//解决el-button点击后不恢复

export const preventDefaultDirective = {
    mounted(el) {
        el._preventDefaultHandler = (e) => e.preventDefault();
        el.addEventListener('mousedown', el._preventDefaultHandler);
    },
    unmounted(el) {
        if (el._preventDefaultHandler) {
            el.removeEventListener('mousedown', el._preventDefaultHandler);
        }
    }
};

// 导出所有指令
export default {
    preventDefault: preventDefaultDirective
};